/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum StateEnumDto {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
}
